<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <form v-on:submit.prevent="submit">
          <buttons top />
        </form>
      </div>
      <div class="col-md-6">
        <h4 style="display: inline-block;">Countries</h4>
        <p>Please add active countries.</p>
        <hr />
        <multiSelectModal
          v-if="countryModalVisable"
          property="provider_countries"
          propertyName="country"
          v-on:close="toggleCountryModal()"
          :search="true"
          :alphabet="true"
        />
        <div>
          <div
            v-for="(country, index) in getProperty(['provider_countries'])"
            class="badge prop-badge"
          >
            {{ getFirst10(country["country"].name) }}
            <button
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_countries')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;"
                >&times;</span
              >
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          style="margin-left: 0px; margin-top: 10px;"
          v-on:click="toggleCountryModal()"
        >
          Add country
        </button>
      </div>

      <div class="col-md-6">
        <h4 style="display: inline-block;">Sectors</h4>
        <p>Please add active sectors.</p>
        <hr />
        <multiSelectModal
          v-if="sectorModalVisable"
          property="provider_sectors"
          propertyName="sector"
          v-on:close="toggleSectorModal()"
        />
        <div>
          <div
            v-for="(sector, index) in getProperty(['provider_sectors'])"
            class="badge prop-badge"
            v-if="sector.sector"
          >
            {{ getFirst10(sector["sector"].name) }}
            <button
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_sectors')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;"
                >&times;</span
              >
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          v-on:click="toggleSectorModal()"
          style="margin-left: 0px; margin-top: 10px;"
        >
          Add sector
        </button>
      </div>
    </div>
    <div class="row" style="margin-top:30px;">
      <div class="col-md-6">
        <h4 style="display: inline-block;">Capital Types</h4>
        <p>Please add the type(s) of capital.</p>
        <hr />
        <multiSelectModal
          v-if="capitalTypeModalVisable"
          property="provider_capital_types"
          propertyName="capital_type"
          v-on:close="toggleCapitalTypeModal()"
        />
        <div>
          <div
            v-for="(capitalType, index) in getProperty([
              'provider_capital_types'
            ])"
            class="badge prop-badge"
            v-if="capitalType.capital_type"
          >
            {{ getFirst10(capitalType["capital_type"].name) }}
            <button
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_capital_types')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;">
                &times;
              </span>
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          style="margin-left: 0px; margin-top: 10px;"
          v-on:click="toggleCapitalTypeModal()"
        >
          Add capital type
        </button>
      </div>

      <div class="col-md-6">
        <h4 style="display: inline-block;">Provider Types</h4>
        <p>Please indicate investor type (up to three).</p>
        <hr />
        <multiSelectModal
          v-if="providerTypeModalVisable"
          property="provider_provider_types"
          propertyName="provider_type"
          v-on:close="toggleProviderTypeModal()"
        />
        <div>
          <div
            v-for="(providerType, index) in getProperty([
              'provider_provider_types'
            ])"
            class="badge prop-badge"
            v-if="providerType.provider_type"
          >
            {{ getFirst10(providerType["provider_type"].name) }}
            <button
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_provider_types')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;"
                >&times;</span
              >
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          style="margin-left: 0px; margin-top: 10px;"
          v-on:click="toggleProviderTypeModal()"
        >
          Add provider type
        </button>
      </div>
    </div>

    <form v-on:submit.prevent="submit">
      <buttons />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import multiSelectModal from "../elements/multiSelectModal.vue";
import buttons from "../elements/buttons.vue";
import utils from "./utils.js";

export default {
  name: "general-info-page",
  components: {
    multiSelectModal: multiSelectModal,
    buttons: buttons
  },
  data: function() {
    return {
      countryModalVisable: false,
      sectorModalVisable: false,
      capitalTypeModalVisable: false,
      providerTypeModalVisable: false
    };
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      providerPropertyToProperty: "providerPropertyToProperty",
      getNewProviderProperty: "getNewProviderProperty"
    })
  },
  methods: {
    deleteProperty: function(index, providerProperty) {
      this.$store.commit("deleteEditedProviderPropertyByKeyChain", [
        providerProperty,
        index
      ]);
    },
    toggleCountryModal(index, provider) {
      this.countryModalVisable = !this.countryModalVisable;
    },
    toggleSectorModal(index, provider) {
      this.sectorModalVisable = !this.sectorModalVisable;
    },
    toggleCapitalTypeModal(index, provider) {
      this.capitalTypeModalVisable = !this.capitalTypeModalVisable;
    },
    toggleProviderTypeModal(index, provider) {
      this.providerTypeModalVisable = !this.providerTypeModalVisable;
    },
    submit: function() {
      utils.post(this);
    },
    getFirst10: function(str) {
      if (str.length > 9) {
        return str.substring(0, 10) + "...";
      } else {
        return str;
      }
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generalInfoPage.vue